import React from "react";
import { useTranslation } from "@lib/i18n";
import { bool } from "prop-types";

import CircularLoader from "@components/shared/Icons/CircularLoader";
import LeadTimeTooltip from "@components/shared/LeadTimeTooltip";

import { getFinalLeadTimeInfo } from "@lib/getLeadTimeInfo";
import { getCarImagePath } from "@shared/v2/lib/getCarImagePath";
import { getStaticAssetURL } from "@lib/getStaticAssetURL";
import { dealType } from "@types";

const BasketHeader = ({
  deal,
  isLoading = false,
  withRemainingText = true,
  showEmissionSticker = false,
}) => {
  const { t } = useTranslation();
  const { leadTime } = getFinalLeadTimeInfo(deal);

  return (
    <div className="p-4 relative lg:p-0">
      <h1
        className="
        text-4xl uppercase font-bold text-balance lg:text-5xl wideScreen:text-6xl text-primaryDark
      "
      >
        {t("basket.summaryOrder")}
      </h1>
      <div className="flex flex-col pb-4">
        {withRemainingText && (
          <div className="text-2xl uppercase text-primaryDark">
            {isLoading ? (
              <CircularLoader size="md" />
            ) : (
              t("leadTimeDisplay.dateNotation", {
                count: leadTime || "-",
                leadTime,
              })
            )}
            <LeadTimeTooltip id="basket-header" />
          </div>
        )}
        <div className="min-w-32 max-w-80 -mt-2 ml-auto">
          <img
            alt={deal.carConfiguration.preconfiguration.label}
            className="w-full"
            src={getStaticAssetURL(
              getCarImagePath(deal.carConfiguration.preconfiguration.id)
            )}
            title={deal.carConfiguration.preconfiguration.label}
          />
        </div>
      </div>

      {showEmissionSticker && (
        <img
          className="absolute left-1 bottom-10 size-23 sm:left-0 sm:size-32"
          src={getStaticAssetURL(
            "/images/gallery/technical-characteristics/emision_sticker.svg"
          )}
        />
      )}
    </div>
  );
};

BasketHeader.propTypes = {
  deal: dealType.isRequired,
  isLoading: bool,
  withRemainingText: bool,
  showEmissionSticker: bool,
};

export default BasketHeader;
